import PromoPreview from "components/PromoPreview";
import { ExtraLinksProductModel, ExtraLink, ProductProps } from "models/WebShop";
import { DragEvent, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ExtraLinksProduct = ({ handleAddProduct, initialProduct, handleFormValidation }: ProductProps) => {
    const params = useParams();

    const defaultLinks: ExtraLink[] = Array(4).fill({ label: "", url: "" });

    const [errors, setErrors] = useState<string[]>(Array(4).fill(""));

    const urlRegex = /^(?:(?:https?):\/\/)?(?:www\.)?[a-z0-9-æøåÆØÅ]+(?:\.[a-z0-9-æøåÆØÅ]+)+[^\s]*$/i;

    const [extraLinks, setExtraLinks] = useState<ExtraLink[]>(
        initialProduct?.extraLinks ?? defaultLinks
    );

    const [previewArgs, setPreviewArgs ] = useState<string>("");

    const [draggedIndex, setDraggedIndex] = useState<number | null>(null);

    const defaultProduct: ExtraLinksProductModel = {
        webShopProductId: 104,
        documentId: params.id ?? "",
        path: "",
        name: "Ekstra lenker",
        payload: "",
        id: params.id ? params.product + params.id : "",
        price: 1500,
        basePrice: 1500,
        extraLinks: extraLinks,
        description: "",
        linkText: "",
    };

    useEffect(() => { setPreviewArgs(generateExtraLinksUrl())} ,extraLinks)


    const generateExtraLinksUrl = () => {
        return  extraLinks
        .filter(link => link.label && link.url)
        .map(link => `${link.label}¤${link.url}`)
        .join(",");

    }

    const handleLinkChange = (index: number, field: keyof ExtraLink, value: string) => {
        const updatedLinks = [...extraLinks];
        updatedLinks[index] = { ...updatedLinks[index], [field]: value };

        const newErrors = [...errors];
        const { label, url } = updatedLinks[index];

        if (url && !urlRegex.test(url)) {
            newErrors[index] = "Ugyldig nettadresse. Vennligst skriv inn en gyldig URL.";
            handleFormValidation?.(false);
        } else if (label && !url) {
            newErrors[index] = "Du kan ikke ha en tekst uten en nettadresse.";
            handleFormValidation?.(false);
        } else {
            newErrors[index] = "";
            handleFormValidation?.(true);
        }

        setExtraLinks(updatedLinks);
        setErrors(newErrors);
        addAction(updatedLinks);
    };

    const addAction = (value: ExtraLink[]) => {
        const updatedProduct: ExtraLinksProductModel = {
            ...defaultProduct,
            extraLinks: value,
        };
        handleAddProduct(updatedProduct);
    };

    const handleDragStart = (index: number) => {
        setDraggedIndex(index);
    };

    const handleDragOver = (e: DragEvent<HTMLLIElement>) => {
        e.preventDefault();
    };

    const handleDrop = (index: number) => {
        if (draggedIndex === null || draggedIndex === index) return;

        const updatedLinks = [...extraLinks];
        const [movedItem] = updatedLinks.splice(draggedIndex, 1);
        updatedLinks.splice(index, 0, movedItem);

        setExtraLinks(updatedLinks);
        addAction(updatedLinks);
        setDraggedIndex(null);
    };

    return (<>

    <div className="d-flex flex-column flex-md-row gap-4 mb-3 mb-md-4 align-items-center">
                  <div className="order-md-last text-center">
                    <img src="/min-bedrift-ill-lenker.svg" width="800" height="520" alt="Ekstra lenker" className="img-fluid cc-mw-220"></img>
                  </div>
                  <div>
                    <ul className="text-muted mb-0 cc-ul-spaced-1">
                      <li>Øk trafikken til bedriftens nettsider.</li>
                      <li>Led kundene direkte til riktig nettside, f.eks. booking, kampanjer, produkter eller tjenester.</li>
                      <li>Skap høyere verdi av trafikken fra 1881.</li>
                    </ul>
                  </div>
                </div>
        <ul id="draggable-list" className="cc-draggable-list list-unstyled mb-2">
            {extraLinks.map((link, index) => (
                <li
                    key={index}
                    draggable
                    onDragStart={() => handleDragStart(index)}
                    onDragOver={handleDragOver}
                    onDrop={() => handleDrop(index)}
                    className="d-flex align-items-start gap-2 mb-2"
                >
                    <span className="cc-drag-handle mt-3 d-none d-lg-inline">⠿</span>
                    <div className="flex-grow-1">
                        <div className="form-floating mb-2">
                            <input
                                type="text"
                                className="form-control border-primary border-opacity-25 border-2"
                                id={`urlTekst${index + 1}`}
                                placeholder="Tekst"
                                maxLength={30}
                                value={link.label}
                                onChange={(e) => handleLinkChange(index, "label", e.target.value)}
                            />
                            <label htmlFor={`urlTekst${index + 1}`}>Tekst</label>
                        </div>
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control border-primary border-opacity-25 border-2"
                                id={`url${index + 1}`}
                                placeholder="Nettstedsadresse"
                                value={link.url}
                                onChange={(e) => handleLinkChange(index, "url", e.target.value)}
                            />
                            <label htmlFor={`url${index + 1}`}>Nettstedsadresse</label>
                        </div>
                        {errors[index] && (
                            <div className="text-danger small mt-1">{errors[index]}</div>
                        )}
                    </div>
                </li>
            ))}
        </ul>
        <p className="text-muted mb-0 cc-fs-xs">Maks 30 tegn i hvert listeelement. <span className="d-none d-lg-inline">Dra og slipp for å endre rekkefølge.</span></p>
        <PromoPreview id={params.id ?? ""} extraLinks={previewArgs}/>
        </>
    );
};

export default ExtraLinksProduct;
